var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lib-accordion" },
    _vm._l(_vm.categories, function (category, index) {
      return _c("lib-accordion-category", {
        key: category.name,
        attrs: {
          "is-selected": _vm.isSelected,
          children: category.children,
          "force-expand": _vm.forceExpand,
        },
        on: {
          clicked: function ($event) {
            return _vm.$emit("clicked", $event)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _vm._t(
                    "header",
                    function () {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(category.name) +
                            "\n            "
                        ),
                      ]
                    },
                    { category: category }
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "default",
              fn: function (props) {
                return [
                  _vm._t(
                    "default",
                    function () {
                      return [
                        _vm._v(
                          "\n                " +
                            _vm._s(props.item) +
                            "\n            "
                        ),
                      ]
                    },
                    { item: props.item }
                  ),
                ]
              },
            },
            {
              key: "action",
              fn: function (action) {
                return [_vm._t("action")]
              },
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }